import LoginPopup from "auth/components/LoginPopup";
import { loginPopupUpdate } from "auth/store/action";
import LocationHandler from "core-lib/components/LocationHandler";
import { GENERIC_ERROR_EVENT } from "core-lib/constants/common";
import { Theme } from "core-lib/constants/setting";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GenericErrorScreens from "ui-v2/components/GenericErrorScreens";
import s from "./GenericUI.module.scss";

const MGTheme = dynamic(() => import("../MGTheme"), {
  ssr: false,
});

export function GenericUI() {
  const loginPopup = useSelector((state: any) => state?.auth?.loginPopup);
  const theme = useSelector((state: any) => state?.setting?.theme);
  const [error, setError] = useState({
    show: false,
    data: null,
  });

  const dispatch = useDispatch();
  const handleLoginPopupUpdate = (payload) => {
    dispatch(loginPopupUpdate(payload));
  };

  useEffect(() => {
    window.addEventListener(GENERIC_ERROR_EVENT, ({ detail }: any) => {
      if (detail) {
        setTimeout(() => {
          setError({ show: true, data: detail });
        }, 0);
      } else {
        setError({ show: false, data: null });
      }
    });
  }, []);

  return (
    <div className={s.generic_ui}>
      {loginPopup.show && (
        <LoginPopup loginPopupUpdate={handleLoginPopupUpdate} />
      )}

      {error.show && (
        <GenericErrorScreens
          onClose={() => {
            setError({ show: false, data: null });
          }}
          errObj={error.data}
        />
      )}
      <LocationHandler />
      {theme === Theme.MG && <MGTheme />}
    </div>
  );
}
